import React from 'react'
import clsx from 'clsx'
import {Icon, Button} from '../components/Button'
import arrow from '../img/icons/arrow.svg'
import {ImgFilters} from './ImgFilters'
import {Tag} from './Tag'

const interval = timer => fn => {
  const id = setInterval(fn, timer)

  return () => clearInterval(id)
}

const every5sec = interval(5000)

const HeroItem = ({
  imgDesktop,
  imgMobile,
  tag,
  button,
  title,
  subTitle,
  className,
  active,
  prev,
  next,
  index,
}) => {
  const style = clsx(
    `absolute inset-0 w-full h-full transition-all ease-in-out duration-1000 transform`,
    active && `translate-x-0`,
    next && `-translate-x-full`,
    prev && `translate-x-full`,
  )

  return (
    <div className={style}>
      <ImgFilters img={imgMobile} transparency paralax className="lg:hidden" />
      <ImgFilters
        img={imgDesktop}
        transparency
        paralax
        className="hidden lg:block"
      />
      <div className="absolute inset-0 px-12 lg:px-36">
        <div className="grid gap-2.5 grid-cols-4 grid-flow-col mt-16 lg:grid-cols-12 lg:gap-4">
          <div className="col-start-1 col-end-5 lg:col-start-1 lg:col-end-8">
            <Tag>{tag}</Tag>
          </div>
          <div className="text-2xl text-white col-start-1 col-end-5 lg:col-start-1 lg:col-end-8 font-baloo text-shadow">
            {title}
          </div>
          <div className="text-base text-white col-start-1 col-end-5 lg:col-start-1 lg:col-end-8 font-muli text-shadow">
            {subTitle}
          </div>
          <Button
            as="a"
            href={button.link}
            className="mt-4 col-start-1 col-end-5"
          >
            {button.label}
          </Button>
        </div>
      </div>
    </div>
  )
}

const inc = x => x + 1
const dec = x => x - 1

const HeroBanner = ({items}) => {
  const hasItems = items.length >= 2
  const [active, setActive] = React.useState(0)
  const intervalRef = React.useRef(() => null)

  const nextSlide = ev => {
    ev && ev.preventDefault()

    if (active + 1 >= items.length) {
      setActive(0)
      return
    }

    setActive(inc)
  }

  const prevSlide = ev => {
    ev && ev.preventDefault()

    if (active <= 0) {
      return
    }

    setActive(dec)
  }

  React.useEffect(() => {
    intervalRef.current()
    intervalRef.current = every5sec(nextSlide)

    return intervalRef.current
  }, [active])

  return (
    <div className="relative w-full h-98">
      <div className="relative flex w-full h-full overflow-hidden">
        {items.map((hero, index) => (
          <HeroItem
            key={hero.title}
            {...hero}
            active={active === index}
            prev={active < index}
            next={active > index}
          />
        ))}
      </div>

      {hasItems && (
        <>
          <div className="absolute inset-y-0 flex items-center w-12 px-2 left">
            <a href="#prev" onClick={prevSlide}>
              <Icon icon={arrow} className="w-4 transform rotate-180" />
            </a>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center w-12 px-2">
            <a href="#next" onClick={nextSlide}>
              <Icon icon={arrow} className="w-4" />
            </a>
          </div>
        </>
      )}
    </div>
  )
}

export {HeroBanner}
